import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>Here are some of the biases that affect our decision making
                                                most often:</p>
                                            <table className="ilead_v_sport tablesrink" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left" valign="center"
                                                        width="20%"><strong>Common</strong></th>
                                                    <th className="green_curve1" align="left"
                                                        valign="center" width="40%"><strong>Biases</strong>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%"><p>Illusion of control</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="80%"><p>Since we’re always subject to
                                                        external factors beyond our control, most of us
                                                        think we have more control over a given situation
                                                        that we really do.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%"><p>Overconfidence</p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="80%"><p>Most of us believe we’re better (at
                                                        most things!) than what is statistically
                                                        calculated as ‘average’. So, for example, 85% of us
                                                        think we’re better than
                                                        average drivers. We make many of our decisions,
                                                        therefore, without seeking
                                                        further information beforehand.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%"><p>Confirmatory bias</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="80%"><p>When we subscribe to a stereotype or
                                                        form our own belief about something
                                                        we’re quicker to notice what confirms it than what
                                                        disproves it, even though
                                                        evidence for and against may exist in equal
                                                        proportions.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%"><p>Attribution error</p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="80%"><p>We commonly attribute our
                                                        disappointments and failures to external
                                                        circumstances,
                                                        for example: ‘The bank’s experiencing a credit
                                                        squeeze, so we didn’t get a loan.’
                                                        But when something goes wrong for others, we’ll
                                                        often assume they’re responsible,
                                                        for example: ‘They didn’t get a loan because they’re
                                                        not creditworthy’.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%"><p>Availability</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="80%"><p>We tend to remember and cite the more
                                                        extreme examples of our own and
                                                        others’ experiences, even if they’re not
                                                        typical.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%"><p>Anchoring</p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="80%"><p>Without realising it, we often base
                                                        our decisions on a particular belief,
                                                        assumption, first impression or other ‘anchor’ of
                                                        information.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%"><p>Sunk cost trap</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="80%"><p>We usually decide how much more to
                                                        invest in a project according to what’s
                                                        already been spent, but that’s a ‘sunk cost’ –
                                                        future decisions should be based
                                                        on future potential.</p>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                  INFLUENCES ON GROUP DECISION MAKING PROCESSES
                   </span></div>

                                            <div className="border_subtitle">Conformity</div>
                                            <p>Many studies<a className="superscripttext"
                                                              href="further_info.php?course=300"><sup>3</sup></a> have
                                                shown that when in groups, we tend to conform. Two of the
                                                most common
                                                reasons for this are a) we want to fit in and be liked by
                                                the rest of the group, or b) we trust the
                                                judgement of others more than our own, in a particular
                                                situation.</p>
                                            <div className="border_subtitle">Minority Influence</div>
                                            <p>Although commonplace, conformity in groups is not inevitable.
                                                Minorities can exert a powerful
                                                influence if they show conviction and keep their arguments
                                                consistent.<a className="superscripttext"
                                                              href="further_info.php?course=300"><sup>4</sup></a>
                                            </p>
                                            <div className="border_subtitle">Obedience</div>
                                            <p>Research<a className="superscripttext"
                                                          href="further_info.php?course=300"><sup>5</sup></a> reveals
                                                we tend to defer to those who are, or seem to be, in a
                                                position of authority –
                                                and agree to, or do, things we wouldn’t otherwise.</p>
                                            <div className="border_subtitle">Group Polarisation</div>
                                            <p>Groups can make riskier decisions than their members would,
                                                individually. We often mistakenly
                                                assume that an idea is substantiated if others agree with it
                                                – and can be persuaded to take it
                                                further, or to extremes.</p>
                                            <div className="border_subtitle">Groupthink<a
                                                className="superscripttext superBold"
                                                href="further_info.php?course=300"><sup>6</sup></a></div>
                                            <p>This is an extreme version of ‘group polarisation’, occurring
                                                when a group lacks diversity and
                                                dissenting voices. Believing that, because everyone involved
                                                thinks alike, decisions reached must
                                                be right, the group either doesn’t look for evidence to the
                                                contrary, or disregards it.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}